//@flow
import { urlsConstants } from '../_constants/urls.constant';
import { userService } from './user.service';
import { estabelecimentoService } from './estabelecimento.service';

export const authenticationService = {
  doLogin,
  doLogout,
  hasToken,
  setToken,
  getTokenOnline,
  setTokenOnline,
  getlocalStorageFull,
  setEstabelecimentoOnline,
  getCurrentEstabelecimentoOnline,
  doLoginSSO,
};

function doLogin(
  username: string,
  password: string,
  perfil,
  loginOnline: boolean
) {
  const clientId: string = process.env.REACT_APP_CLIENT_ID || '';
  const clientPassword: string = process.env.REACT_APP_CLIENT_PASSWORD || '';

  const details = {
    client_id: clientId,
    grant_type: 'password',
    username,
    password,
    perfil,
    loginOnline,
  };

  const formBody = Object.keys(details).map(
    (key) => encodeURIComponent(key) + '=' + encodeURIComponent(details[key])
  );

  const basicAuthorization = btoa(clientId + ':' + clientPassword);

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: '*/*',
      Connection: 'keep-alive',
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Basic ' + basicAuthorization,
    },
    body: formBody.join('&'),
  };

  return fetch(urlsConstants.OAUTH_TOKEN, requestOptions)
    .then(async (response) => {
      if (!response.ok) {
        const error = await response.json();
        console.error('Falha no login:', error);
        return Promise.reject(error);
      }
      return response.json();
    })
    .then((token) => {
      if (token) {
        setToken(JSON.stringify(token));
      }
      return token;
    });
}

function doLoginSSO(cpf, perfil) {
  const clientId = process.env.REACT_APP_CLIENT_ID || '';
  const clientPassword = process.env.REACT_APP_CLIENT_PASSWORD || '';

  const basicAuthorization = btoa(clientId + ':' + clientPassword);

  const formBody = [
    'grant_type=password',
    'username=' + encodeURIComponent(cpf),
    'password=' + encodeURIComponent('autossometadoc'),
    'perfil=' + encodeURIComponent(perfil),
  ].join('&');

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: '*/*',
      Authorization: 'Basic ' + basicAuthorization,
    },
    body: formBody,
  };

  return fetch(urlsConstants.OAUTH_TOKEN, requestOptions)
    .then(async (response) => {
      if (!response.ok) {
        const error = await response.json();
        console.error('Falha no login SSO:', error);
        return Promise.reject(error);
      }
      return response.json();
    })
    .then((token) => {
      if (token) {
        setToken(JSON.stringify(token));
      }
      return token;
    });
}

function setToken(token) {
  return localStorage.setItem('token', token);
}

function setTokenOnline(tokenOnline) {
  return localStorage.setItem('tokenOnline', tokenOnline);
}

function setEstabelecimentoOnline(estabelecimento) {
  return localStorage.setItem(
    'estabelecimentoOnline',
    JSON.stringify(estabelecimento)
  );
}
function getCurrentEstabelecimentoOnline() {
  let estabelecimentoOnline = localStorage.getItem('estabelecimentoOnline');
  if (!estabelecimentoOnline) {
    return null;
  }
  let estabelecimento = JSON.parse(estabelecimentoOnline);
  return estabelecimento;
}

function getlocalStorageFull() {
  return localStorage;
}

function hasToken() {
  return localStorage.getItem('token') !== null;
}

function getTokenOnline() {
  return localStorage.getItem('tokenOnline');
}

function doLogout() {
  var tokenOnline = localStorage.getItem('tokenOnline');
  var estabelecimentoOnline = localStorage.getItem('estabelecimentoOnline');
  localStorage.clear();
  localStorage.setItem('tokenOnline', tokenOnline);
  localStorage.setItem('estabelecimentoOnline', estabelecimentoOnline);
}
